const sharedSettings = {
  system_area_name: { editable: true, type: 'hm-area-select', rules: [{ required: true }] },
  user: { editable: true, type: 'habit-user-select', rules: [{ required: true }] },

  area_name: { hidden: true },
  user_email: { hidden: true },

  created_at: { hidden: true },
  updated_at: { hidden: true },
}

export const settings = {
  id: { label: "ID" },
  ...sharedSettings
};

export const initialSettings = {
  id: { hidden: true },
  ...sharedSettings,
}

export const initialValues = {
  system_area_name: null,
  user: null
};
